import React from "react";

function RoadSVG({ colorCode = "", seaClass = "" }) {
  return (
    <svg className={`MuiSvgIcon-root ${seaClass}`} viewBox="0 0 32 20">
      <path
        fill={colorCode}
        d="M31.037,9.962l-2.54-0.521l-1.204-3.646c-0.424-1.302-1.629-2.149-2.996-2.149h-2.051V1.757
	c0-0.651-0.554-1.205-1.205-1.205h-1.498v12.34H1.082v2.084c0,0.651,0.554,1.205,1.205,1.205h1.302c0,1.889,1.563,3.451,3.452,3.451
	c1.888,0,3.451-1.563,3.451-3.451h12.08c0,1.889,1.563,3.451,3.451,3.451c1.889,0,3.452-1.563,3.452-3.451h1.302
	c0.651,0,1.204-0.554,1.204-1.205v-3.842C32.014,10.581,31.623,10.093,31.037,9.962z M7.041,17.81c-0.912,0-1.628-0.717-1.628-1.628
	c0-0.912,0.716-1.629,1.628-1.629s1.628,0.717,1.628,1.629C8.668,17.093,7.952,17.81,7.041,17.81z M22.246,9.116V5.469h2.051
	c0.586,0,1.074,0.358,1.27,0.912l0.912,2.735H22.246z M26.055,17.81c-0.879,0-1.627-0.717-1.627-1.628
	c0-0.912,0.748-1.629,1.627-1.629c0.912,0,1.629,0.717,1.629,1.629C27.684,17.093,26.934,17.81,26.055,17.81z"
      />
      <path
        fill={colorCode}
        d="M18.783,0.802H2.093c-0.687,0-1.236,0.549-1.236,1.236v10.268h17.926V0.802z"
      />
    </svg>
  );
}

export default RoadSVG;
